<template>
    <BaseLoader :loader="loader" />

 
    <base-dialog :show="error != null" :showCloseIcon="false" title="Something Fishy" @close="error = null">
            <template v-slot:content>                  
                    <div class="inv-wrapper nwd-wrap">
                        <div class="inv-form-item">
                                <label>{{error}}</label>    
                        </div>
                    </div>
            </template>
            <template v-slot:actions>
                    <base-button class="app-icon large-btn" @click="error=null" title="Close">
                        <app-icon icon="hugeicons:cancel-square" width="18" />
                    </base-button>                  
            </template>
    </base-dialog>

    <base-dialog :show="showDialog" :title="dialogTitle" @close="closeDialog" :windowWidth="720">
        <template v-slot:content>
            <!-- Tab Navigation -->
            <div class="tab-navigation">
                <button 
                    class="tab-button" 
                    :class="{ active: activeTab === 'tab-1' }"
                    @click="activeTab = 'tab-1'"
                >
                    <app-icon icon="hugeicons:user-account" width="18" />
                    <span>Streamer Info</span>
                </button>
                <button 
                    class="tab-button" 
                    :class="{ active: activeTab === 'tab-2' }"
                    @click="activeTab = 'tab-2'"
                >
                    <app-icon icon="hugeicons:database-setting" width="18" />
                    <span>Streamer Tags</span>
                </button>
            </div>

            <!-- Tab Content -->
            <div class="dialog-form tab-1" v-show="activeTab === 'tab-1'">
                <div class="form-row form-row-with-avatar">
                    <div class="form-group">
                        <label class="form-label">Streamer UID</label>
                        <input type="text" v-model="dialogData.Uid" class="form-input">
                        <div class="form-input-hint" v-if="dialogData.Name"><a :href="'https://sullygnome.com/channel/' + dialogData.Name" target="_blank">Show stats</a></div>
                    </div>
                    <div class="form-group avatar-group">
                        <label class="form-label">Avatar</label>
                        <div class="avatar-container">
                            <img 
                                v-if="dialogData.Avatar" 
                                :src="dialogData.Avatar" 
                                alt="Streamer Avatar"
                                class="avatar-image"
                                @error="handleImageError"
                            >
                            <div v-else class="avatar-placeholder">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-group form-group-full">
                        <label class="form-label">Streamer Name</label>
                        <input type="text" v-model="dialogData.Name" class="form-input">
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-group form-group-full">
                        <label class="form-label">Profile Link <a v-if="dialogMode !== 'new'" :href="dialogData.Profile" target="_blank">Check it</a></label>
                        <input type="text" v-model="dialogData.Profile" class="form-input">
                    </div>
                </div>
                
                <div class="form-row">
                    <div v-if="dialogMode !== 'new'" class="form-group">
                        <label class="form-label">Live Status</label>
                        <div class="status-indicator">
                            <input type="text" v-model="dialogData.Live" readonly class="form-input readonly-field">
                            <span class="live-badge" :class="{ 'is-live': dialogData.Live }">
                                {{ dialogData.Live ? 'LIVE' : 'OFFLINE' }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Streamer Status</label>
                        <vue-select
                            class="form-input-select" 
                            :key="selectKey"
                            v-model="dialogData.StreamerStatusId" 
                            :options="streamerStatusToEdit" 
                            label-by="Status"
                            value-by="Id"                      
                            clear-on-close 
                            close-on-select  /> 
                    </div>                    
                </div>                
               
                
            </div>
            <div class="dialog-form tab-2" v-show="activeTab === 'tab-2'">
                
                <div class="tag-manager">
                                        
                    <p class="form-label">Tags</p>
                    <div v-if="selectedTagsObjects.length" class="chips-container">
                        <div 
                            v-for="tag in selectedTagsObjects" 
                            :key="tag.Id" 
                            :class="[{ 'chip': true, 'all-tag': tag.Id == 1 }]"
                        >
                            {{ tag.Tag }}
                            <span class="remove-icon" @click="removeTag(tag.Id)">&times;</span>
                        </div>
                    </div>
                    <div v-else>
                        <p class="small-inf">No tags selected</p>
                    </div>

                    <div class="input-group">
                    <label class="form-label" for="tag-select">New tag:</label>
                    <vue-select 
                        id="tag-select"
                        class="form-input-select tag-select"
                        v-model="selectedTagToAdd" 
                        :options="remainingTags" 
                        label-by="Tag"
                        value-by="Id"
                        placeholder="Select a tag..."
                        :disabled="remainingTags.length === 0"
                        @update:modelValue="handleTagSelect"
                        searchable
                        clear-on-close                          
                    />
                    </div>
                   
                </div>


            </div>
        </template>
        <template v-slot:actions>
            <div :class="['actions-result', { error: onSaveError }]">
                {{ onSaveResult }}
            </div>
            <base-button class="app-icon large-btn" @click="closeDialog" title="Close">
                <app-icon icon="hugeicons:cancel-square" width="18" />
            </base-button>     
            <base-button class="app-icon icon-blue large-btn" @click="saveStreamer" title="Save">
                <app-icon icon="hugeicons:floppy-disk" width="18" />
            </base-button>             
        </template>
    </base-dialog>



  <div class="admin-container">
    <NaviPanel />

    <main class="main-layout">
      <NaviHeader />

      <div class="content-scroll">

        <div class="cs-card">
            <h3>Streamer list</h3>
            <p class="text-tooltip">Manage streamers who display campaign banners in their live streams.</p>

            <button class="spec-btn refresh-btn" @click="streamerList" title="Refresh">
                <app-icon icon="hugeicons:refresh-dot" width="18" />
            </button>
        </div>
        
        <div class="cs-card cs-animation">
            

            <div class="cs-filter">
                <div class="filter-item">
                    <label for="status">Status</label>
                  
                    <vue-select 
                        :key="selectKey"
                        v-model="selectedStatus" 
                        :options="streamerStatusDict" 
                        label-by="Status"
                        value-by="Id"
                        @update:modelValue="streamerList"
                        class="vue-select thin"                         
                        clear-on-close 
                        close-on-select  />   
                </div>
                <div class="filter-item">
                    <label for="live">Is Live</label>
                  
                    <vue-select 
                        :key="selectKey"
                        v-model="selectedLive" 
                        :options="liveStatusDict" 
                        label-by="Status"
                        value-by="Id"
                        @update:modelValue="streamerList"
                        class="vue-select thin"                         
                        clear-on-close 
                        close-on-select  />   
                </div>
                <div class="filter-item filter-item-btn">
                    <span class="filter-label">New Streamer</span>
                    <button @click="dialogModeBtnClick(0,'new')" class="app-icon"><app-icon icon="hugeicons:credit-card-add" width="18" /></button>
                </div>
            </div>

            <div class="center-pan">
                    <vue-good-table
                        :columns="table1columns"
                        :rows="table1rows"
                        :line-numbers="false"
                        :search-options="{enabled: true}"
                        :sort-options="{enabled: true}"
                        :pagination-options="{
                                enabled: true,
                                mode: 'records'
                        }" 
                                    
                    >
                        <template v-slot:emptystate>
                        No data
                        </template>

                        

                        <template v-slot:table-row="props">
                            <div v-if="props.column.field == 'Action'">
                                <button title="Edit" class="app-icon" :name="props.row.Id" @click="dialogModeBtnClick(props.row.Id, 'edit')">
                                    <app-icon icon="hugeicons:chat-edit-01" width="18" />
                                </button>
                                <button title="Change status" class="app-icon icon-blue" :name="props.row.Id" @click="changeStatus(props.row.Id)">
                                    <app-icon icon="hugeicons:card-exchange-01" width="18" />
                                </button>
                            </div>

                            <span v-else-if="props.column.field == 'Live'">
                                <app-icon 
                                    v-if="props.row.Live" 
                                    icon="hugeicons:live-streaming-01" 
                                    width="24" 
                                    style="color: var(--blue);" 
                                />
                                <app-icon 
                                    v-else 
                                    icon="hugeicons:cellular-network-offline" 
                                    width="18" 
                                    style="color: gray;" 
                                />
                            </span>

                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                        
                    </vue-good-table>
            </div>
        </div>        

      </div>
    </main>
  </div>
</template>


<script>
    import NaviPanel from '@/components/NaviPanel.vue';
    import NaviHeader from '@/components/NaviHeader.vue';
    import BaseLoader from '@/components/BaseLoader.vue';

    import shared from "@/shared";
    import apiService from "@/services/other.js";

    export default {
        components: { NaviPanel, NaviHeader, BaseLoader},
        name: 'StreamersView',

        data: function () {
            return {
                loader: false,
                error: null,
                onSaveError: false,
                onSaveResult: '',
                activeTab: 'tab-1',
                table1columns: [
                  {
                  label: 'Streamer Id',
                  field: 'Id',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Streamer Uid',
                  field: 'Uid',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Streamer Name',
                  field: 'Name',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Is live',
                  field: 'Live',
                  tdClass: 'text-f12 text-center'
                  },
                  {
                  label: 'Status',
                  field: 'StreamerStatus',
                  tdClass: 'text-f12'
                  },
                  {
                  label: 'Active Campaign No',
                  field: 'InActiveCampaignNo',
                  tdClass: 'text-f14'
                  },                  
                  {
                  label: '',
                  field: 'Action',
                  tdClass: 'text-center',
                  sortable: false,
                  width: '128px',
                  }
                ],
                table1rows: [], 
                streamerStatusDict: [], 
                streamerStatusToEdit: [],
                allAvailableTags: [],
                selectedTagIds: [1],
                selectedTagToAdd: null,                
                liveStatusDict: [{Id: -1, Status: '-All-'}, {Id: 0, Status: 'Offline'}, {Id: 1, Status: 'Live'}], 
                selectedStatus: -1,
                selectedLive: -1,
                selectKey: 0,
                showDialog: false,
                dialogMode: 'new',
                dialogTitle: 'New Streamer',
                dialogData: {}
            };
        },
        created() {           
            this.streamerList();
            this.statusDict();   
            this.streamerAttributesList();        
            
        },

        mounted() {
            
        },

        computed: {
            // Zwraca pełne obiekty tagów na podstawie wybranych ID
            selectedTagsObjects() {
            return this.allAvailableTags.filter(tag => 
                this.selectedTagIds.includes(tag.Id)
            );
            },
            // Zwraca tagi, których użytkownik jeszcze NIE wybrał
            remainingTags() {
            return this.allAvailableTags.filter(tag => 
                !this.selectedTagIds.includes(tag.Id)
            );
            }
        },

        methods: {    


            streamerList() {
            
                const data = {
                    ResultName: "streamerList", 
                    Live: this.selectedLive === null ? -1 : this.selectedLive, 
                    StreamerStatus: this.selectedStatus === null ? -1 : this.selectedStatus 
                };

                console.log('data');
                console.log(data);
                
                this.loader = true;
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.table1rows = response.data;  

                            console.log(this.table1rows);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '102', true, e))
                    .finally(() => {
                        this.loader = false;
                    });
            },

            streamerAttributesList() {
                const data = {ResultName: "streamerAttributesDict"};
                this.loader = true;
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {     

                        this.allAvailableTags = [
                            { Id: 1, Tag: '-All-' },
                            ...response.data
                        ];
                        // console.log('allAvailableTags');
                        // console.log(this.allAvailableTags);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '104', true, e))
                    .finally(() => {
                        this.loader = false;
                    });
            },


            statusDict() {
            
                const data = {ResultName: "streamerStatusDict"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.streamerStatusToEdit = response.data;
                        
                            const options = [{ Id: -1, Status: '-All-' }, ...response.data];
                            this.streamerStatusDict = options;
                            
                            this.selectedStatus = -1;
                            this.selectKey++

                            //console.log(this.streamerStatusDict);

                    }
                    })
                    .catch((e) => shared.handleError.call(this, '103', true, e));
            },


            changeStatus(id) {

                const data = {ResultName: "streamerStatusChange", StreamerId: id};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200 && response.data.success) {                  
                            
                            this.streamerList();

                    }
                    else {
                        this.error = 'Code(104a): '+response.data.text;
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '105', true, e));
                
            },

            dialogModeBtnClick(id, mode) {
                this.dialogMode = mode;
                this.showDialog = true;

                if (mode == 'new') {
                    this.dialogData.Id = 0;
                    this.dialogData.Uid = '';
                    this.dialogData.Name = '';
                    this.dialogData.Live = false;
                    this.dialogData.Profile = '';
                    this.dialogData.Avatar = '';
                    this.dialogData.StreamerStatus = 'Active';
                    this.dialogData.StreamerStatusId = 1;
                    this.dialogData.InActiveCampaignNo = 0;
                    this.selectedTagIds = [1];
                }
                else {
                    this.dialogTitle = 'Edit Streamer';
                    const row = this.table1rows.find(item => item.Id === id);
                    this.dialogData = { ...row };

                    const attributeIds = (this.dialogData.Attributes ?? []).map(a => a.AttributeId);     
  
                    this.selectedTagIds = attributeIds;
                }
               
            },  

            closeDialog() {
                this.showDialog = false;
                this.dialogMode = 'new';
                this.dialogTitle = 'New Streamer';
                this.dialogData = {};
                this.activeTab = 'tab-1'; // Reset to first tab
            },

            saveStreamer() {
                
                this.dialogData.Attributes = this.selectedTagIds;
                console.log(this.dialogData);

                let data = null;

                if (this.dialogMode == 'new') {
                    data = {ResultName: "streamerAdd", 
                        Uid: this.dialogData.Uid, 
                        Name: this.dialogData.Name, 
                        Profile: this.dialogData.Profile, 
                        StreamerStatusId: this.dialogData.StreamerStatusId, 
                        Attributes: this.dialogData.Attributes};
                } else {
                    data = {ResultName: "streamerEdit", 
                        StreamerId: this.dialogData.Id, 
                        Uid: this.dialogData.Uid, 
                        Name: this.dialogData.Name, 
                        Profile: this.dialogData.Profile, 
                        StreamerStatusId: this.dialogData.StreamerStatusId, 
                        Attributes: this.dialogData.Attributes};
                }


                
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200 && response.data.success) {                  
                            
                            this.onSaveError = false;
                            this.onSaveResult = 'Excellent! Streamer saved successfully.';
                            setTimeout(() => {
                                this.onSaveResult = '';
                                this.showDialog = false;
                                this.streamerList();
                            }, 2500);

                    }
                    else {
                        this.onSaveError = true;                        
                        this.onSaveResult = 'Code(106a): '+response.data.text;
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '106', true, e));


            },

            handleImageError() {
                // If avatar image fails to load, clear it to show placeholder
                this.dialogData.Avatar = '';
            },

            handleTagSelect(tagId) {
                if (tagId) {
                    this.addTag(tagId);
                    this.selectedTagToAdd = null;
                }
            },
            addTag(id) {
                if (id === 1) {
                    this.selectedTagIds = [1];
                } 
                
                else {
                    this.selectedTagIds = this.selectedTagIds.filter(tagId => tagId !== 1);
                    if (!this.selectedTagIds.includes(id)) {
                        this.selectedTagIds.push(id);
                    }
                }
            },
            removeTag(id) {
                this.selectedTagIds = this.selectedTagIds.filter(tagId => tagId !== id);
            },
            
        },


    }
</script>



<style scoped>
  

  .form-row-with-avatar {
    align-items: flex-start;
    margin-bottom: 0px !important;
  }

  .avatar-group {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .avatar-container {
    width: 116px;
    height: 90px;
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid var(--border);
    background-color: var(--bg-page);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .avatar-container:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    background: linear-gradient(135deg, var(--bg-page) 0%, #e0e4ea 100%);
  }

  .avatar-placeholder svg {
    width: 60%;
    height: 60%;
    opacity: 0.5;
  }


  .form-input-hint {
    margin-top: 4px;
    margin-right: 3px;
    text-align: right;
  }
  

  .form-input-hint a {
    color: var(--blue);
    text-decoration: none;
    font-size: 12px;
  }

  .form-input-hint a:hover {
    text-decoration: underline;
  }


</style>